import { render } from "./ViolationList.vue?vue&type=template&id=9fcb8cbe&scoped=true"
import script from "./ViolationList.vue?vue&type=script&lang=js"
export * from "./ViolationList.vue?vue&type=script&lang=js"

import "./ViolationList.vue?vue&type=style&index=0&id=9fcb8cbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fcb8cbe"]])

export default __exports__